type CapabilityCheck = (key: string) => boolean;

export const GRID_EXPORT_CAPABILITY = 'export_grid_data';

/** Capabilities that have always opened the admin panel, and that grid export still requires. */
const ADMIN_TOOL_CAPABILITIES = ['edit_permissions', 'manage_users', 'manage_openers',
  'reconcile_ingestion', 'review_deal_close_requests'];

/**
 * Who can open the admin panel. The people who run deal prep
 * (send_deal_prep_history) get in for Admin > Deal Prep Intake only, and
 * default layout managers (manage_default_layouts) for Admin > Grid Columns
 * only (REG-828); every child route still checks its own capability (REG-859).
 */
export function canAccessAdminArea(isSuperAdmin: boolean, hasCapability: CapabilityCheck): boolean {
  return isSuperAdmin
    || [...ADMIN_TOOL_CAPABILITIES, 'send_deal_prep_history', 'manage_default_layouts'].some(hasCapability);
}

/** Grid export keeps its original rule: the deal prep capability alone never unlocks it. */
export function canExportGridData(isSuperAdmin: boolean, hasCapability: CapabilityCheck): boolean {
  return isSuperAdmin || (hasCapability(GRID_EXPORT_CAPABILITY) && ADMIN_TOOL_CAPABILITIES.some(hasCapability));
}
